/**
 * @class
 */
import Base from '@netx/core/lib/netx-model';

class Sorter extends Base {
	/**
	 * @property {object} defaults            - Model defaults
	 * @property {string} defaults.field      - Sort field
	 * @property {string} defaults.sortOrder  - Sort order (asc, desc)
	 */
	get defaults() {
		return {
			field: '',
			order: 'desc',
		};
	}

	/** @override */
	constructor(attrs, opts = {}) {
		super(attrs, opts);

		/**
		 * If not provided, the keys of the collection's models will be used
		 * @memberof module:app/models/sorter
		 * @alias sortableFields
		 * @type {array}
		 */
		this.sortableFields =
			opts.sortableFields || _.keys(this.collection.model.GetDefaults());

		/**
		 * @memberof module:app/models/sorter
		 * @alias sortableOrders
		 * @type {array}
		 */
		this.sortableOrders = opts.sortableOrders || ['asc', 'desc'];

		// Hey, listen!
		this.listenTo(
			this,
			'change',
			_.debounce((sorter, opts) => {
				this.collection[this.collection.preferredFetchMethod || 'fetch'](
					_.extend({duplicateQueryPolicy: 'abort'}, opts),
				);
			}, 15),
		);
	}

	/**
	 * @method
	 * @return {object}
	 */
	getSortDTO() {
		return this.self();
	}

	/**
	 * @method
	 * @param {string} field Field
	 * @param {string} order Order
	 */
	setSort(field, order) {
		order = order || 'desc';
		// Normalize
		if (order === 'descending') order = 'desc';
		if (order === 'ascending') order = 'asc';

		if (!_.contains(this.sortableFields, field)) {
			throw new Error('Invalid sort `field` "' + field + '"');
		}
		if (!_.contains(this.sortableOrders, order)) {
			throw new Error('Invalid sort `order` "' + order + '"');
		}

		return this.set({
			field: field,
			order: order,
		});
	}

	/** @type {string} */
	static get __name__() {
		return 'Sorter';
	}
}

export default Sorter;
